import { makeChartComp } from '../../util/makeChartComp';
var WordCloudChart = makeChartComp('WordCloud');
export default WordCloudChart;
